import React from "react";
import { Row, Col, Form, Input, Select } from "antd"; // Import Select from Ant Design
import classes from "../Pages.module.css";


const { Option } = Select; // Destructure Option from Select

const FormRenderer = (props) => {
  console.log(props, "dfdff");

  const handleChange = (e, param) => {
    console.log(e.target.value);
    console.log(param);
    props.setData((data) => {
      const newdata = [...data["accountHeader"]];
      console.log(newdata);

      newdata[0][param] = e.target.value;

      return {
        ...data,
        accountHeader: newdata,
      };
    });
  };

  const handleSelectChange = (value, param) => {
    console.log(value);
    console.log(param);
    props.setData((data) => {
      const newdata = [...data["accountHeader"]];
      console.log(newdata);
     
      newdata[0][param] = value;
      return {
        ...data,
        accountHeader: newdata,
      };
    });
  };

  return (
    <Row className={classes["RowDE"]}>
      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Allowance Description <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Description"
              value={
                props.save ? props.data.allowance_desc : props.data.allowance_desc
              }
              onChange={(e) => handleChange(e, "allowance_desc")}
              bordered={false}
              style={{
                width: "100%",
                backgroundColor: "white",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>

      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold",
                }}
              >
                Allowance Type <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Select
              placeholder="Select Allowance Type"
              value={
                props.save ? props.data.allowance_type : props.data.allowance_type
              }
              onChange={(value) => handleSelectChange(value, "allowance_type")}
              style={{ width: "100%" }}
            >
             
                <Option
                  style={{ textTransform: "capitalize", color: "#1777C4" }}
                  key='+'
                  value='+'
                >
                 +
                </Option>
                <Option
                  style={{ textTransform: "capitalize", color: "#1777C4" }}
                  key='-'
                  value='-'
                >
                 -
                </Option>
              
            </Select>
          </Form.Item>
        </Form>
      </Col>

      <Col span={8} style={{ margin: "auto" }}>
        {props.save ? (
          <button
            onClick={(event) => props.handleSubmit(event)}
            className={classes["ProfileButtonF"]}
          >
            Add Record
          </button>
        ) : null}
      </Col>
    </Row>
  );
};

export default FormRenderer;
